import { render, staticRenderFns } from "./luxury-homepage-quick-links.vue?vue&type=template&id=0c2be422&scoped=true&"
var script = {}
import style0 from "./luxury-homepage-quick-links.vue?vue&type=style&index=0&id=0c2be422&lang=scss&scoped=true&"
import style1 from "./luxury-homepage-quick-links.vue?vue&type=style&index=1&id=0c2be422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2be422",
  null
  
)

export default component.exports